import type { Halloween2026Variant } from '~/features/promotions/utils/get-halloween-2026-variant';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { halloween2026CampaignCore } from './campaign-core';
import { halloween2026CampaignSurfaces } from './surfaces';

export { HALLOWEEN_2026_CAMPAIGN_ID, halloween2026CampaignCore } from './campaign-core';

const halloween2026PromoCampaignTyped = {
  ...halloween2026CampaignCore,
  surfaces: halloween2026CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<Halloween2026Variant>;

export const halloween2026PromoCampaign = halloween2026PromoCampaignTyped as RegisteredPromoCampaign;
